export function ExecuteREGLCommand(regl, drawCommand, vertexAttrType) {
  drawCommand({
    position: vertexAttrType.position,
    time: vertexAttrType.time,
    mousePos: vertexAttrType.mousePos,
    mainColor: vertexAttrType.mainColor,
    textureAspectRatio: vertexAttrType.textureAspectRatio,
    screenAspectRatio: vertexAttrType.screenAspectRatio,
    isMouseEnable: vertexAttrType.isMouseEnable,
    textureLerpValue: vertexAttrType.textureLerpValue
  });
}
export function CreateFrameBufferCommand(regl, frameBuffer, frameBufferTex, vertex, fragment, noiseTex, a_uv, scale, minRevealRange, vertex_count) {
  return regl({
    framebuffer: frameBuffer,
    frag: fragment,
    vert: vertex,
    attributes: {
      a_position: regl.prop("position"),
      a_uv
    },
    uniforms: {
      u_scale: scale,
      u_noise_tex: regl.texture({data: noiseTex, wrap: "repeat"}),
      u_min_reveal_range: minRevealRange,
      u_reveal_map_tex: frameBufferTex,
      u_tex_aspect_ratio: regl.prop("textureAspectRatio"),
      u_screen_aspect_ratio: regl.prop("screenAspectRatio"),
      u_time: regl.prop("time"),
      u_mousePos: regl.prop("mousePos"),
      u_isMouseEnable: regl.prop("isMouseEnable")
    },
    count: vertex_count
  });
}
export function CreateCanvasREGLCommand(regl, frameBuffer, vertex, fragment, noiseTex, frontTexA, highlightTexA, frontTexB, highlightTexB, a_uv, scale, minRevealRange, isMobile, vertex_count) {
  return regl({
    frag: fragment,
    vert: vertex,
    attributes: {
      a_position: regl.prop("position"),
      a_uv
    },
    uniforms: {
      u_scale: scale,
      u_noise_tex: regl.texture({data: noiseTex, wrap: "repeat"}),
      u_front_tex_a: frontTexA,
      u_highlight_tex_a: highlightTexA,
      u_front_tex_b: frontTexB,
      u_highlight_tex_b: highlightTexB,
      u_reveal_map_tex: frameBuffer,
      u_min_reveal_range: minRevealRange,
      u_is_mobile: isMobile,
      u_color: regl.prop("mainColor"),
      u_tex_aspect_ratio: regl.prop("textureAspectRatio"),
      u_time: regl.prop("time"),
      u_mousePos: regl.prop("mousePos"),
      u_isMouseEnable: regl.prop("isMouseEnable"),
      u_textureLerpValue: regl.prop("textureLerpValue")
    },
    count: vertex_count
  });
}
